import { Modal } from 'antd'
import axios, { AxiosInstance } from 'axios'
import { getEnvVars } from 'Environment'
import { useRecoilValue } from 'recoil'
import { authAtom } from 'recoil/Login/atoms'
export { useAxiosWrapper }

function useAxiosWrapper() {
	const auth = useRecoilValue(authAtom)

	const { apiUrl } = getEnvVars()

	const axiosInstance: AxiosInstance = axios.create({
		baseURL: apiUrl,
		withCredentials: false,
	})

	axiosInstance.interceptors.request.use((request) => {
		if (auth && request && request.headers) {
			request.headers['Authorization'] = `Bearer ${auth?.access_token}`
		}

		return request
	})

	axiosInstance.interceptors.response.use(
		(response) => {
			return response
		},
		(error) => {
			const errorData = error?.response?.data
			const abpError = errorData?.error
			const baseMessage = errorData?.error_description ? errorData.error_description : abpError?.message || error.message
			const details = abpError?.details
			const validationErrors = abpError?.validationErrors

			let messageError = baseMessage
			if (details) {
				messageError += `\n\n${details}`
			}
			if (Array.isArray(validationErrors) && validationErrors.length > 0) {
				const formatted = validationErrors
					.map((v: any) => {
						const members = Array.isArray(v?.members) && v.members.length > 0 ? ` (${v.members.join(', ')})` : ''
						return `- ${v?.message || 'Validation error'}${members}`
					})
					.join('\n')
				messageError += `\n\nValidation errors:\n${formatted}`
			}
			const modal = Modal.error({})
			modal.update({
				title: 'Error',
				bodyStyle: { maxHeight: '80vh', overflowY: 'auto' },
				content: <pre>{messageError}</pre>,
				width: '60em',
			})
			return Promise.reject(error)
		}
	)

	return axiosInstance
}
